import { ColorLike } from 'outpost';
import { CSSProperties } from 'outpost/preact';
import { toCssPixels } from '../utils.ts';

export type SeparatorProps = {
    style?: CSSProperties;
    width?: number | `${number}%`;
    height?: number | `${number}%`;
    color?: ColorLike;
    grow?: boolean;
};

export function Separator(props: SeparatorProps) {
    let style: CSSProperties = {
        backgroundColor: props.color as string,
        width: toCssPixels(props.width),
        height: toCssPixels(props.height),
        alignSelf: 'stretch',
        grow: props.grow ? 1 : 0,
        ...props.style
    };

    return <div style={style} />;
}